export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const LOAN_PURPOSE_PERSONAL = "Personal";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const LOAN_PURPOSE_NOVATED_LEASE = "Novated Lease";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";
export const ABN_STATUS_NEW_ABN = "New Business ABN";
export const BOAT_ASSET_TYPE_COMMERCIAL = "Commercial Boat";

// Initialised loan types
export const ALL_LOAN_TYPES =
	"Car Loan,Boat Loan,Caravan Loan,Truck Loan,Equipment Loan,Mortgage Loan,Business Loan";
export const LOAN_TYPE_CAR = "Car Loan";
export const LOAN_TYPE_BOAT = "Boat Loan";
export const LOAN_TYPE_CARAVAN = "Caravan Loan";
export const LOAN_TYPE_TRUCK = "Truck Loan";
export const LOAN_TYPE_EQUIPMENT = "Equipment Loan";
export const LOAN_TYPE_MORTGAGE = "Mortgage Loan";

// Mortgage Loan Purpose
export const LOAN_PURPOSE_MORTGAGE_BUILD = "Build a Home";
export const LOAN_PURPOSE_MORTGAGE_REFINANCE = "Refinance Existing Home Loan";
export const LOAN_PURPOSE_MORTGAGE_INVESTMENT = "Purchase an Investment Property";
export const LOAN_PURPOSE_MORTGAGE_OCCUPY = "Buy a Home to Live In";

// Property Type
export const PROPERTY_TYPE_NEW = "Newly Built Home";
export const PROPERTY_TYPE_EXISTING = "Existing Home";
export const PROPERTY_TYPE_LAND = "Land";
export const PROPERTY_TYPE_OFF_THE_PLAN = "Off-the-Plan Home";

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

export const callDays = [
	{
		option: "Any",
		value: "Any",
		id: 0,
	},
	{
		option: "Monday",
		value: "Monday",
		id: 1,
	},
	{
		option: "Tuesday",
		value: "Tuesday",
		id: 2,
	},
	{
		option: "Wednesday",
		value: "Wednesday",
		id: 3,
	},
	{
		option: "Thursday",
		value: "Thursday",
		id: 4,
	},
	{
		option: "Friday",
		value: "Friday",
		id: 5,
	},
	{
		option: "Saturday",
		value: "Saturday",
		id: 6,
	},
	{
		option: "Sunday",
		value: "Sunday",
		id: 7,
	},
];

export const stateOption = [
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];

// Note: IDs are mapped to Ambition
export const loan_type = [
	{
		option: "Car Loan",
		id: 1,
		value: "Car Loan",
	},
	{
		option: "Boat Loan",
		id: 2,
		value: "Boat Loan",
	},
	{
		option: "Truck Loan",
		id: 8,
		value: "Truck Loan",
	},
	{
		option: "Equipment Loan",
		id: 6,
		value: "Equipment Loan",
	},
	{
		option: "Caravan Loan",
		id: 4,
		value: "Caravan Loan",
	},
	{
		option: "Mortgage Loan",
		id: 5,
		value: "Mortgage Loan",
	},
];

export const loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
];

export const car_loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
	{
		option: "Novated Lease",
		id: 1,
		value: "Novated Lease",
	},
];

export const boat_asset_type = [
	{
		option: "Boat",
		value: "Boat",
	},
	{
		option: "Jet Ski / PWC",
		value: "Jet Ski / PWC",
	},
	{
		option: "Sailboat / Yacht",
		value: "Sailboat / Yacht",
	},
	{
		option: "Houseboat",
		value: "Houseboat",
	},
	{
		option: "Commercial Boat",
		value: "Commercial Boat",
	},
];

export const equipment_asset_type = [
	{
		option: "Assets",
		value: "Assets",
	},
	{
		option: "Vehicle",
		value: "Vehicle",
	},
	{
		option: "General",
		value: "General",
	},
];

export const purchase_stage = [
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Found One - Ready to Finance",
		value: "Found One - Ready to Finance",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
];

export const living_status = [
	{
		option: "Home Owner - With Mortgage",
		id: 1,
		value: "Home Owner - With Mortgage",
	},
	{
		option: "Home Owner - No Mortgage",
		id: 2,
		value: "Home Owner - No Mortgage",
	},
	{
		option: "Renting",
		id: 3,
		value: "Renting",
	},
	{
		option: "Living with Family",
		id: 4,
		value: "Living with Family",
	},
];

export const employment_status = [
	{
		option: "Full time",
		id: 1,
		value: "Full time",
	},
	{
		option: "Part time",
		id: 2,
		value: "Part time",
	},
	{
		option: "Casual",
		id: 3,
		value: "Casual",
	},
	{
		option: "Self-employed",
		id: 4,
		value: "Self-employed",
	},
	{
		option: "Contractor",
		id: 11,
		value: "Contractor",
	},
	{
		option: "Retired",
		id: 9,
		value: "Retired",
	},
	{
		option: "Self-funded Retiree",
		id: 10,
		value: "Self-funded Retiree",
	},
	{
		option: "Government Benefits",
		id: 7,
		value: "Government Benefits",
	},
];

export const credit_history = [
	{
		option: "Good",
		value: "Good",
	},
	{
		option: "Fair",
		value: "Fair",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "Unsure",
		value: "Unsure",
	},
];

export const abn_status = [
	{
		option: "New Business ABN",
		value: "New Business ABN",
	},
	{
		option: "Less than 1 Year",
		value: "Less than 1 Year",
	},
	{
		option: "More than 1 Year",
		value: "More than 1 Year",
	},
];

export const gst_status = [
	{
		option: "Not registered for GST",
		value: "Not registered for GST",
	},
	{
		option: "6 Months +",
		value: "6 Months +",
	},
	{
		option: "12 Months +",
		value: "12 Months +",
	},
];

// Business Loan
export const LOAN_PURPOSE_EQUIPMENT = "Equipment Finance";

export const yesNoOptions = [
	{
		option: "Yes",
		id: 1,
		value: "Yes",
	},
	{
		option: "No",
		id: 2,
		value: "No",
	},
];

// Mortgages

export const LOAN_PURPOSE_BUY_A_HOME = "Buy a Home";
export const LOAN_PURPOSE_REFINANCE_MORTGAGE = "Refinance my Mortgage";

// Consultation Page Options
export const loan_purpose_mortgage = [
	{
		option: "Buy a Home to Live In",
		id: 1,
		value: "Buy a Home to Live In",
	},
	{
		option: "Purchase an Investment Property",
		id: 2,
		value: "Purchase an Investment Property",
	},
	{
		option: LOAN_PURPOSE_MORTGAGE_REFINANCE,
		id: 3,
		value: LOAN_PURPOSE_MORTGAGE_REFINANCE,
	},
	{
		option: "Build a Home",
		id: 4,
		value: "Build a Home",
	},
];

export const mortgage_loan_purpose = [
	{
		option: LOAN_PURPOSE_BUY_A_HOME,
		value: LOAN_PURPOSE_BUY_A_HOME,
	},
	{
		option: LOAN_PURPOSE_REFINANCE_MORTGAGE,
		value: LOAN_PURPOSE_REFINANCE_MORTGAGE,
	},
];

export const first_home_buyers = [
	{
		option: "Yes",
		value: "Yes",
	},
	{
		option: "No",
		value: "No",
	},
];

export const PROPERTY_PURPOSE_OCCUPY = "Owner Occupied";
export const PROPERTY_PURPOSE_INVESTMENT = "Investment Property";

export const property_purpose = [
	{
		option: PROPERTY_PURPOSE_OCCUPY,
		value: PROPERTY_PURPOSE_OCCUPY,
	},
	{
		option: PROPERTY_PURPOSE_INVESTMENT,
		value: PROPERTY_PURPOSE_INVESTMENT,
	},
];

export const fixed_rate = [
	{
		option: "Yes",
		value: "Yes",
	},
	{
		option: "No",
		value: "No",
	},
];

export const property_purchase_stage = [
	{
		option: "Exploring Options",
		value: "Exploring Options",
	},
	{
		option: "Looking to Purchase Within 6 Months",
		value: "Looking to Purchase Within 6 Months",
	},
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Made an Offer",
		value: "Made an Offer",
	},
];

export const property_type = [
	{
		option: "New Build/Off the Plan",
		value: "New Build/Off the Plan",
	},
	{
		option: "Established Home",
		value: "Established Home",
	},
	{
		option: "Vacant Land to Build On",
		value: "Vacant Land to Build On",
	},
];

export const refinance_purpose = [
	{
		option: "Decrease Payments",
		value: "Decrease Payments",
	},
	{
		option: "Pay Off Loan Faster",
		value: "Pay Off Loan Faster",
	},
	{
		option: "Consolidate Debt",
		value: "Consolidate Debt",
	},
	{
		option: "Build/Renovations",
		value: "Build/Renovations",
	},
];

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	"Car Loan": {
		loanPurpose: [...car_loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Boat Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [...boat_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Truck Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Equipment Loan": {
		loanPurpose: [loan_purpose[1]],
		purchaseStage: [...purchase_stage],
		assetType: [...equipment_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Caravan Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Mortgage Loan": {
		loanPurpose: [...mortgage_loan_purpose],
		firstHomeBuyer: [...first_home_buyers],
		propertyPurpose: [...property_purpose],
		fixedRate: [...fixed_rate],
		purchaseStage: [...property_purchase_stage],
		assetType: [...property_type],
		refinancePurpose: [...refinance_purpose],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
};

export const stepProcessMap: Record<string, Record<string, any>> = {
	// Default Steps for all Loan Types except Mortgage
	Default: [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Details",
		},
		{
			id: 3,
			name: "Living Details",
		},
		{
			id: 4,
			name: "Additional Information",
		},
		{
			id: 5,
			name: "Completed",
		},
	],
	// Steps for LOAN_TYPE_MORTGAGE Type
	"Mortgage Loan": [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Details",
		},
		{
			id: 3,
			name: "Purchase Details",
		},
		{
			id: 4,
			name: "Living Details",
		},
		{
			id: 5,
			name: "Additional Information",
		},
		{
			id: 6,
			name: "Completed",
		},
	],
	// Consultation Form Steps for Mobile Only
	Consultation: [
		{
			id: 0,
			name: "Availability",
		},
		{
			id: 1,
			name: "Finance Option",
		},
		{
			id: 2,
			name: "Personal Details",
		},
		{
			id: 3,
			name: "Completed",
		},
	],
};

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Yes Boat Loans": {
		themeColor: "#1768ac",
		hoverColor: "#031b4e",
		themeHeaderTxt: "#03256c",
		bulletBG: "#DBEAFE",
	},
	"Yes Car Loans": {
		themeColor: "#AD2831",
		hoverColor: "#800e13",
		themeHeaderTxt: "#142f48",
		bulletBG: "#f5d0d4",
	},
	"Yes Caravan Loans": {
		themeColor: "#F68104",
		hoverColor: "#D7760F",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFE3C1",
	},
	"Yes Equipment Loans": {
		themeColor: "#007F5F",
		hoverColor: "#1B4332",
		themeHeaderTxt: "#142f48",
		bulletBG: "#D0FAE5",
	},
	"Yes Truck Loans": {
		themeColor: "#FFC300",
		hoverColor: "#FFAA00",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFEDB6",
	},
	"Yes Home Loans": {
		themeColor: "#FFAA22",
		hoverColor: "#F69D0E",
		themeHeaderTxt: "#142F48",
		bulletBG: "#FFDFB8",
	},
};
